import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import fetch, { fetchConfig } from '@/hooks/fetch';
import { fetchConfiguration } from '@/configurations/actions';
import { configurationCodes } from '@/configurations/constants';
import { toggleRoleSelected } from '../actions';
import RoleRow from '../components/RoleRow';

const RolesTableRows = ({
  allowConfigurationRead,
  category,
  columns,
  defaultRole,
  fetchDefaultRole,
  items,
  onCheckBoxClick,
  readStatus,
  selectable,
}) => {
  fetch.useFetchByCode(
    fetchDefaultRole,
    'all',
    configurationCodes.DEFAULT_ROLE,
    readStatus,
    fetchConfig([defaultRole], () => allowConfigurationRead),
  );

  return (
    items.map((item, index) => (
      <RoleRow
        category={category}
        columns={columns}
        defaultRole={defaultRole === item.code}
        key={`roles_table_row_${item.code}`}
        onCheckBoxClick={onCheckBoxClick}
        role={item}
        selectable={selectable}
        upward={index > 4}
      />
    ))
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { configurations: { read } } } },
  configurations: { configurations },
}) => {
  const { value, readStatus } = findResult(configurations, 'all', configurationCodes.DEFAULT_ROLE) || {
    value: { value: '' },
    readStatus: states.NONE,
  };

  return {
    allowConfigurationRead: read,
    defaultRole: value.value,
    readStatus,
  };
};

const mapDispatchToProps = {
  onCheckBoxClick: toggleRoleSelected,
  fetchDefaultRole: fetchConfiguration,
};

export default connect(mapStateToProps, mapDispatchToProps)(RolesTableRows);
